import React, { FC } from 'react';
import styled from 'styled-components';

type Props = {
  unreadCount: number;
};

export const UnReadCountLabel: FC<Props> = ({ unreadCount }) => {
  return <StyledWrapper>{unreadCount}</StyledWrapper>;
};

const StyledWrapper = styled.div`
  position: absolute;
  top: 1em;
  right: 1.1em;
  left: inherit;
  z-index: 100;
  width: 1.5em;
  min-width: 1.5em;
  height: 1.5em;
  min-height: 1.5em;
  font-size: 0.8rem;
  font-weight: 700;
  padding: 0.5em;
  border-radius: 500rem;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  background-color: #ff981a;
`;
